import { InMemoryCache, makeVar } from '@apollo/client';

import cerberusRelayStylePagination from './helper';

export const pageThemeVar = makeVar('');
export const selectedTradingPairVar = makeVar('');
export const exchangesDataVar = makeVar<
	| {
			id: number;
			exchangeName: string;
			iconUrl: string;
			themeIconUrl?: { light: string; dark: string };
			price: string;
			sPrice: string;
			nodes: [];
	  }[]
	| []
>([]);
export const providersDataVar = makeVar<
	| {
			id: number;
			name: string;
			icon: string;
	  }[]
	| []
>([]);
export const priceMedianVar = makeVar('0');
export const priceHistoryRowVar = makeVar<{
	average: string;
	price?: string;
	createdAt: string;
	id: string;
	tradingPair: string;
	rawPriceMedian?: string;
	cc_hash?: string;
} | null>(null);
export const consensusAnimationShouldStop = makeVar(false);
export const consensusStopPollingVar = makeVar(false);
export const consensusStartHidingVar = makeVar(false);
export const consensusCountdownVar = makeVar(0);

const cache = new InMemoryCache({
	typePolicies: {
		LocalState: {
			fields: {
				pageTheme: {
					read() {
						return pageThemeVar;
					},
				},
				consensusCountdown: {
					read() {
						return consensusCountdownVar();
					},
				},
				selectedTradingPair: {
					read() {
						return selectedTradingPairVar();
					},
				},
				exchangesData: {
					read() {
						return exchangesDataVar();
					},
				},
				providersData: {
					read() {
						return providersDataVar();
					},
				},
				priceMedian: {
					read() {
						return priceMedianVar();
					},
				},
				consensusStopPolling: {
					read() {
						return consensusStopPollingVar();
					},
				},
				consensusStartHiding: {
					read() {
						return consensusStartHidingVar();
					},
				},
				priceHistoryRow: {
					read() {
						return priceHistoryRowVar();
					},
				},
			},
		},
		Simulation: {
			fields: {
				transactions: cerberusRelayStylePagination(),
				nodes: cerberusRelayStylePagination(),
			},
		},
		Instrument: {
			keyFields: ['tradingPair'],
			merge: true,
		},
		CatalogInstrument: {
			keyFields: ['tradingPair'],
			merge: true,
		},
		Catalog: {
			keyFields: ['instrumentId', 'displayName'],
		},
		CatalogPrice: {
			keyFields: false,
		},
	},
});

export default cache;
